import { render, staticRenderFns } from "./family.vue?vue&type=template&id=7174b49c&scoped=true&"
import script from "./family.vue?vue&type=script&lang=js&"
export * from "./family.vue?vue&type=script&lang=js&"
import style0 from "./family.vue?vue&type=style&index=0&id=7174b49c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174b49c",
  null
  
)

export default component.exports